<template>
  <transition name="fade">
    <div v-if="showNotification" class="botao-rolagem">
      <keep-alive>
        <component v-bind:is="showComponentHeader" />
      </keep-alive>
      <button class="notificacao" @click="showNotificacoes(true)">
        <div class="atualizacao" v-if="showButton">
          <span class="dot"></span>
          <span class="dot pulse"></span>
        </div>
        <img src="@/assets/imgs/icone_notificacoes.png" />
      </button>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Notificacoes from '@/components/Notificacoes.vue';
import env from '../config/env';

export default {
  name: 'BotaoNotificacao',
  components: {
    Notificacoes,
  },
  computed: {
    ...mapGetters({
      showButton: 'notificacoes/showButton',
      showComponentHeader: 'notificacoes/showComponentHeader',
      showNotify: 'notificacoes/showNotify',
      showFalandoDeGente: 'notificacoes/showFalandoDeGente',
    }),
    showNotification() {
      return ( this.showNotify || this.showFalandoDeGente ) && env.revista.canal === 6;
    },
  },
  methods: {
    ...mapActions({
      habilitaNotificacoes: 'notificacoes/enabledNotify',
      showNotificacoes: 'notificacoes/showNotificacoes',
      existeNotificacao: 'notificacoes/existeNotificacao',
    }),

    voltarAoTopo() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  },
  mounted() {
    this.$nextTick(async () => {
      const notify = await this.habilitaNotificacoes();
      if (notify) {
        this.existeNotificacao();
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.botao-rolagem {
  position: relative;

  > button {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  & .dot {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 12px;
    height: 12px;
    border-radius: 20px;
    background: #f44336;
  }

  & .pulse {
    animation: pulse 3s linear infinite;
  }

  & .notificacao {
    display: flex;
    flex-direction: center;
    justify-content: center;
    @extend %nao-selecionavel;
    font-family: 'OpenSans';
    background-color: $cor_roxo;
    color: $cor_roxo;
    font-size: 15px;
    width: 40px;
    height: 40px;
    line-height: 0px;
    border-radius: 100px;
    border: 0px;
    text-align: center;
    outline: none;
    transition: all 0.2s linear;
    cursor: pointer;
    padding: 0px;
    padding-bottom: 0px !important;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
    margin-top: 5px;

    & img {
      align-self: center;
      width: 20px;
      height: 20px;
    }

    &:hover {
      transform: scale(1.2);
    }
    &:focus {
      animation: grow 0.25s linear;
    }
  }
}
@keyframes grow {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes pulse {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  40% {
    transform: scale(2);
    opacity: 0;
  }
  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .botao-rolagem {
    & .notificacao {
      font-size: 15px;
      width: 40px;
      height: 40px;
      bottom: 65px;
      right: 10px;
      padding-bottom: 0;

      &:hover {
        transform: none;
      }
    }
    & .mover {
      bottom: 110px;
    }

    & .dot {
      top: -0.2vh;
      right: -0.4vh;
    }
  }
}
/**
  Transition
 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
